import { useSelector } from 'react-redux';

// import { IRootState } from 'shared/types/redux';

export const useAppSelector = useSelector;

export default useAppSelector;
